import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { ThemeProvider, StyledEngineProvider } from '@mui/material/styles';
import { ThemeProvider as StylesThemeProvider } from '@mui/styles';
import CssBaseline from '@mui/material/CssBaseline';
import store from './store';
import App from './App';
import registerServiceWorker from './registerServiceWorker';
import theme from './shared/theme';
import './index.css';

// Filter out axios errors from console in development
if (process.env.NODE_ENV === 'development') {
  const originalConsoleError = console.error;
  console.error = (...args) => {
    const message = args[0]?.toString() || '';
    if (
      message.includes('AxiosError') ||
      message.includes('Request failed') ||
      message.includes('status code')
    ) {
      return;
    }
    originalConsoleError.apply(console, args);
  };
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <StyledEngineProvider injectFirst>
    <ThemeProvider theme={theme}>
      <StylesThemeProvider theme={theme}>
        <CssBaseline />
        <Provider store={store}>
          <App />
        </Provider>
      </StylesThemeProvider>
    </ThemeProvider>
  </StyledEngineProvider>
);
registerServiceWorker();
